import { OrderErrorResponse, OrderSuccessResponse, OrderTypes } from "../../../models/orders";
import { OptionTimeframe, TradeDirection } from "../GTT/gttTypes";

export const getOrderProduct = (currentGttTab: OptionTimeframe): OrderTypes | undefined => {
  switch (currentGttTab) {
    case "CarryForward":
      return "DELIVERY";
    case "Delivery":
      return "DELIVERY";
    case "Intraday":
      return "INTRADAY";
    case "T+5":
      return "BTST";
    case "MTF":
      return "MTF";
    default:
      return undefined;
  }
};


export const isSuccessResponse = (data: any): data is OrderSuccessResponse => {
  return data?.status === "success";
};

// Type guard to check if data is OrderErrorResponse
export const isErrorResponse = (data: any): data is OrderErrorResponse => {
  return data?.status === "error";
};

export const orderMultiplier = (
  tradeDirection: TradeDirection,
  selected: OptionTimeframe,
  available_margin: number,
  ltp: number
): number => {
  const Intraday: number = 5; // Always 5
  switch (tradeDirection) {
    case "Buy":
      switch (selected) {
        case "Intraday":
          return Intraday;
        case "MTF":
          return ltp / Math.abs(available_margin); // const
        case "CarryForward":
          return 1;
        case "Delivery":
          return 1;
        case "T+5":
          return ltp / Math.abs(available_margin); // const
        default:
          console.warn("Buy - Default option selected");
          return Intraday;
      }
    case "Sell":
      switch (selected) {
        case "Intraday":
          return Intraday;
        case "MTF": 
          return 1; 
        case "CarryForward":
          return 1;
        case "Delivery":
          return 1;
        case "T+5":
          return 1;
        default:
          console.warn("Sell - Default option selected");
          return 1;
      }
    default:
      console.warn("Default case - Invalid direction selected");
      return 1;
  }
};